import { Translation } from '../types/translations';

const cs: Translation = {
    companies: {
        title: 'Společnosti',
        filters: 'Filtry',
        activeFilters: 'aktivní',
        reset: 'resetovat',
        listOfMatches: 'Nalezených záznamů',
        loadMore: 'Načíst další společnosti',
        searchByIdVat: 'Hledat podle IČ/DIČ',
        allSizes: 'Všechny velikosti',
        allPriceLists: 'Všechny ceníky',
        settings: 'Nastavení tabulky',
    },
    errors: {
        companyNotFound: 'Společnost nenalezena',
        somethingWentWrong: 'Něco se pokazilo. Zkuste to prosím znovu později nebo kontaktujte podporu.',
    },
    generic: {
        cancel: 'Zrušit',
        close: 'Zavřít',
        loading: 'Načítám',
        no: 'Ne',
        ok: 'OK',
        yes: 'Ano',
    },
    login: {
        changePassword: 'Změnit heslo',
        confirmPassword: 'Potvrďte heslo',
        currentPassword: 'Současné heslo',
        email: 'Email',
        emailCheck: 'Zadejte prosím platný email',
        forgottenPwd: 'Zapomenuté heslo?',
        loginError: 'Přihlášení se nezdařilo. Zkontrolujte prosím své přihlašovací údaje.',
        newPassword: 'Nové heslo',
        noAccount: 'Nemáte účet?',
        password: 'Heslo',
        passwordChanged: 'Heslo bylo úspěšně změněno.',
        passwordCheck: 'Zadejte prosím heslo',
        passwordNotChanged: 'Nepodařilo se změnit heslo. Prosím zkontrolujte současné heslo.',
        passwordsNotMatch: 'Hesla se neshodují',
        remember_me: 'Zapamatovat si mě',
        signIn: 'Přihlásit se',
        signUpNow: 'Zaregistrovat se nyní',
        unknownError: 'Přihlášení se nezdařilo. Zkontrolujte prosím své přihlašovací údaje, nebo to zkuste později.',
        logoAlt: 'Logo Bindfind',
        showPassword: 'Zobrazit heslo',
        hidePassword: 'Skrýt heslo',
    },
    menu: {
        about: 'O nás',
        analytics: 'Analytika',
        codebooks: 'Číselníky',
        companies: 'Společnosti',
        contact: 'Kontakt',
        dashboard: 'Přehled',
        help: 'Nápověda',
        home: 'Domů',
        profile: 'Profil',
        settings: 'Nastavení',
    },
    tour: {
        generic: {
            next: 'Další',
            previous: 'Předchozí',
            finish: 'Dokončit',
        },
        filters: {
            name: 'Filtry',
            description:
                'Použijte filtry pro zúžení seznamu společností. Můžete filtrovat podle názvu, stavu a dalších kritérií.',
        },
        tableSettings: {
            name: 'Nastavení tabulky',
            description: 'Zde můžete upravit nastavení tabulky, jako jsou sloupce a jejich pořadí.',
        },
        columnReorder: {
            name: 'Přesun sloupců',
            description:
                'Přetáhněte sloupce pro změnu jejich pořadí. Toto nastavení bude uloženo a použito při příštím načtení tabulky.',
        },
    },
    mfa: {
        backupCode: 'Náhradní kód',
        codeEmpty: 'Prosím zadejte kód',
        disable: 'Vypnout',
        disableTitle: 'Vypnout vícefaktorové ověření',
        disabled: 'Vícefaktorové ověření bylo vypnuto.',
        enable: 'Aktivovat',
        enabled: 'Vícefaktorové ověření bylo aktivováno.',
        enableText1: 'Vícefaktorové ověření byulo aktivováno. Pro dokončení postupujte podle pokynů níže.',
        enableText2: '1. Otevřete ověřovací aplikaci dle své volby',
        enableText3: '2. Naskenujte QR kód nebo vložte tajný klíč ručne',
        enableText4: '3. Ověřte kód vygenerovaný aplikací',
        enableText5:
            'Tohle je list jednorázových náhradních kódů. Bezpečně je uschovejte, už se k nim nebudete moct vrátit.',
        enableTitle: 'Aktivovat vícefaktorové ověření',
        enterCode: 'Vložte ověřovací kód vygenerovaný vaší ověřovací aplikací',
        invalidCode: 'Neplatný verifikační kód',
        mfa: 'Vícekrokové ověření',
        sureToDisable: 'Určite chcete vypnout vícefaktorové ověření?',
        twoFactorTitle: 'Dvoufaktorové ověření',
        useAuthenticator: 'Použít ověřovací kód z oveřovací aplikace',
        useBackupCode: 'Nemáte přístup k ověřovací aplikaci? Použijte jednorázový náhradní kód',
        verificationCode: 'Ověřovací kód',
        verify: 'Ověřit',
        verifyAndEnable: 'Ověřit a aktivovat',
    },
    selectedCompany: {
        branchDetail: {
            branchDetail: 'Detail pobočky',
            keyContactPresent: 'V pobočce se nachází klíčový kontakt',
        },
        branches: {
            addBranch: 'Přidat pobočku',
            companyBranches: 'Pobočky firmy',
            contactPersons: 'Kontaktní osoby + kontakty',
        },
        companyDetail: {
            addComp: 'Přidat firmu',
            central: 'Sídlo',
            compDetail: 'Detail firmy',
            dic: 'DIČ',
            fieldIds: 'Činnost',
            ic: 'IČ',
            noBranches: 'Žádné pobočky nenalezeny',
            numofemployees: 'zaměstnanců',
            openGoogleMap: 'Otevřít v Google Maps',
            priceListId: 'Ceník',
            retry: 'Zkusit znovu',
        },
        contacts: {
            contactDetail: 'Detail kontaktu',
            position: 'Pozice',
            verified: 'Ověřený kontakt',
        },
        generic: {
            email: 'Email',
            fav: 'Oblíbené',
            inactive: 'Neaktivní společnost',
            lastContact: 'Poslední kontakt',
            nextContact: 'Následující kontakt',
            note: 'Pozn.',
            phone: 'Tel.',
            referentId: 'Referent',
            state: 'Stát',
            statutId: 'Status',
            unfav: 'Zrušit oblíbené',
            www: 'Web',
        },
    },
    filters: {
        apply: 'Použít',
        hide: 'Skrýt',
        remove: 'Odebrat',
    },
    sidebar: {
        banner: 'Reklamní plocha',
        text: 'Toto je reklamní plocha. Můžete ji použít k zobrazení některých informací nebo propagačních zpráv.',
    },
    tables: {
        detail: {
            loadMore: 'Načíst více',
            noMoreRecords: 'Žádné další záznamy k načtení',
        },
        branchesTable: {
            contacted: 'Kontaktováno',
            keyContact: 'Klíčový kontakt',
        },
        companyTable: {
            address: 'Adresa',
            addressDetails: 'Detaily adresy',
            addressDetails2: 'Další detaily adresy',
            capitalAmount: 'Základní kapitál',
            cityDistrict: 'Městská část',
            countryId: 'ID země',
            county: 'Kraj',
            createdById: 'Vytvořil (ID)',
            createdDate: 'Datum vytvoření',
            district: 'Okres',
            email: 'Email',
            establishedDate: 'Datum založení',
            ic: 'IČ',
            id: 'ID',
            imported: 'Importováno',
            legalFormId: 'ID právní formy',
            mainLanguageId: 'ID hlavního jazyka',
            mainScopeId: 'ID hlavního oboru',
            mainSourceUrl: 'Hlavní zdroj URL',
            municipality: 'Obec',
            name: 'Název',
            otherInfo: 'Další informace',
            registrationId: 'ID registrace',
            registrationLastChange: 'Poslední změna registrace',
            size: 'Velikost',
            status: 'Stav',
            street: 'Ulice',
            terminationDate: 'Datum ukončení',
            terminationType: 'Typ ukončení',
            useIc: 'Použít IČ',
            validationScore: 'Skóre validace',
            vat: 'DIČ',
            village: 'Vesnice',
            website: 'Webová stránka',
            zipCode: 'PSČ',
        },
    },
    user: {
        email: 'Email',
        middleName: 'Střední jméno',
        name: 'Jméno',
        surname: 'Přijmení',
    },
    enums: {
        companyLegalForm: {
            sro: 'Společnost s ručením omezeným',
            as: 'Akciová společnost',
            gmbh: 'Gesellschaft mit beschränkter Haftung',
            ag: 'Aktiengesellschaft',
            sarl: 'Société à responsabilité limitée',
            sa: 'Société anonyme',
            ltd: 'Private Limited Company',
            llc: 'Limited Liability Company',
            inc: 'Incorporated',
            corp: 'Corporation',
            srl: 'Società a responsabilità limitata',
            sl: 'Sociedad limitada',
            srl_it: 'Società a responsabilità limitata (Itálie)',
            spa: 'Società per azioni',
            kft: 'Korlátolt felelősségű társaság',
            nv: 'Naamloze vennootschap',
            ab: 'Aktiebolag',
            asa: 'Allmennaksjeselskap',
            as_ee: 'Aktsiaselts',
            ou: 'Osaühing',
            ooo: 'Obshchestvo s ogranichennoi otvetstvennostyu',
            tov: 'Tovarishchestvo s ogranichennoi otvetstvennostyu',
            vos: 'Veřejná obchodní společnost',
            ks: 'Komanditní společnost',
            lp: 'Limited Partnership',
            llp: 'Limited Liability Partnership',
            sole: 'Fyzická osoba – podnikatel',
            coop: 'Družstvo',
            foundation: 'Nadace',
            association: 'Spolek / asociace',
            soe: 'Státní podnik',
            not_specified: 'Neuvedeno',
        },
        companyLegalFormType: {
            limited_liability: 'Společnost s ručením omezeným',
            joint_stock: 'Akciová společnost',
            partnership: 'Společnost osobní',
            sole_proprietorship: 'Fyzická osoba – podnikatel',
            cooperative: 'Družstvo',
            foundation: 'Nadace',
            association: 'Spolek / asociace',
            state_enterprise: 'Státní podnik',
            branch: 'Pobočka',
            insurance: 'Pojišťovna',
            other: 'Jiné',
        },
        companyScopeType: {
            administration_accounting: 'Administrativa a účetnictví',
            safety_rescue_fire_ohs: 'Bezpečnost a záchrana (po, bozp)',
            workshop_hobby_metal_wood: 'Dílna a hobby (kovo, dřevo)',
            rail_transport: 'Doprava kolejová',
            air_transport: 'Doprava letecká',
            land_transport: 'Doprava pozemní',
            water_transport: 'Doprava vodní',
            transport_services_infrastructure: 'Doprava, služby a infrastruktura',
            drugstore_hygiene: 'Drogerie a hygiena',
            ecology_environment: 'Ekologie, životní prostředí',
            electrical_equipment: 'Elektrická zařízení',
            electrical_installation: 'Elektroinstalace',
            electrical_appliances: 'Elektrospotřebiče',
            energy_heating_power: 'Energie, teplo, energetika',
            finance_leasing_insurance: 'Finance, leasing, pojištění',
            music_musical_instruments: 'Hudba, hudební nástroje',
            interior_furnishings: 'Interiér a vybavení',
            it_hardware_electronics: 'IT, hardware a elektronika',
            it_software_services: 'IT, software a služby',
            office_supplies_paper: 'Kancelářské potřeby, papír',
            jewelry_watches_clocks: 'Klenoty, šperky, hodiny',
            landscape_gardening_pet_supplies: 'Krajina, zahradnictví, chovatelské potřeby',
            forestry_logging: 'Lesnictví, těžba dřeva',
            materials_metals_chemistry: 'Materiály, kovy, chemie',
            sea_fishing: 'Moře a rybolov',
            hunting_gamekeeping: 'Myslivost, lov',
            unclassified: 'Nezařazeno',
            trade_advertising_sales_support: 'Obchod, reklama, podpora prodeje',
            waste_recycling: 'Odpady a recyklace',
            personal_care_spa: 'Osobní péče, lázně',
            hospitality_accommodation: 'Pohostinství a ubytování',
            food_beverages_tobacco: 'Potraviny, nápoje, tabák',
            precision_instruments_optics: 'Přesné přístroje a zařízení, optika',
            real_estate_property: 'Reality, nemovitosti',
            distribution_water_electricity_gas: 'Rozvody (voda, elektřina, plyn)',
            storage: 'Skladování, manipulace',
            foundry_metallurgy: 'Slévárenství, metalurgie',
            justice_courts_law: 'Spravedlnost, soudy a právo',
            construction_architecture_engineering: 'Stavebnictví, architektura, inženýring',
            machinery_equipment: 'Stroje a zařízení',
            machinery_equipment_parts: 'Stroje a zařízení, díly',
            machinery_equipment_work: 'Stroje a zařízení, práce',
            telecommunications_media: 'Telekomunikace a média',
            textiles_clothing_footwear_leather: 'Textil, oděvy, obuv, kůže',
            mining_quarries: 'Těžba, doly',
            cleaning_sanitation: 'Úklid a čištění',
            science_research_development: 'Věda, výzkum, vývoj',
            public_social_services: 'Veřejné a sociální služby',
            military_industry: 'Vojenský průmysl',
            publishing_printing_photography: 'Vydavatelství, tisk a foto',
            education_training: 'Vzdělávání a školení',
            ventilation_heating_plumbing: 'Vzduchotechnika, vytápění a vodoinstalace',
            entertainment_sports_recreation: 'Zábava, sport, rekreace',
            healthcare_medical_services: 'Zdravotnictví, zdravotní péče',
            agriculture_plants: 'Zemědělství, rostliny',
            agriculture_animals: 'Zemědělství, zvířata',
            agriculture_mixed: 'Zemědělství, smíšené',
            undefined: 'Neurčeno / prázdné',
        },
        companySize: {
            a: 'A',
            b: 'B',
            c: 'C',
            d: 'D',
            e: 'E',
            f: 'F',
        },
        companyStatus: {
            active: 'Aktivní',
            active_validated: 'Aktivní ověřená',
            blocked: 'Blokovaná',
            blocked_auto: 'Automaticky blokovaná',
            deleted: 'Smazaná',
        },
        companyTerminationType: {
            bankrupt: 'Bankrot',
            terminated: 'Ukončeno',
        },
        contactStatus: {
            not_validated: 'Neověřený',
            validated: 'Ověřený',
            hidden: 'Skrytý',
            deleted: 'Smazaný',
        },
        contactType: {
            0: 'Email',
            1: 'Telefon',
        },
        country: {
            Czechia: 'Česko',
        },
        personStatus: {
            gdpr_inactive: 'Neaktivní (GDPR)',
            active: 'Aktivní',
            active_validated: 'Aktivní ověřený',
            hidden: 'Skrytý',
            deleted: 'Smazaný',
        },
        userRole: {
            guest: 'Host',
            user: 'Uživatel',
            company_administrator: 'Správce společnosti',
            company_owner: 'Majitel společnosti',
            admin: 'Administrátor',
            superadmin: 'Superadministrátor',
        },
        userStatus: {
            active: 'Aktivní',
            inactive: 'Neaktivní',
            active_validated: 'Aktivní ověřený',
            blocked: 'Blokovaný',
            blocked_auto: 'Automaticky blokovaný',
            hidden: 'Skrytý',
            deleted: 'Smazaný',
        },
    },
};

export default cs;
